import React, { useEffect } from 'react';
import { BsCheck } from 'react-icons/bs';
import { useForm } from 'react-hook-form';
import { useGetEtaiementsList, useCreateEtaiement } from '~/hooks/etaiements';
import styles from './create-etaiement.module.scss';

import { StyledSelect } from '~/lib/HooksFormFields';

const CreateEtaiement = ({
  clientId,
  onSuccess,
} : {
  clientId?: string,
  onSuccess: (etaiementId: string) => void,
}) => {
  const { control, setValue, handleSubmit } = useForm();
  const { data: list = {} } = useGetEtaiementsList();
  const {
    isLoading,
    mutateAsync: createEtaiement,
  } = useCreateEtaiement();

  useEffect(() => {
    if (!clientId) return;
    setValue('client', clientId);
  }, [clientId]);

  const {
    agencies = [],
    clients = [],
  } = list;

  useEffect(() => {
    if (agencies.length === 1) {
      setValue('agency', agencies[0].value);
    }
  }, [agencies]);

  const submit = async (data: any) => {
    try {
      const { etaiement } = await createEtaiement(data);
      onSuccess(etaiement._id);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

  return (
    <div className={styles.form}>
      <h3>Créer un devis étaiement</h3>
      <div className={styles.fields}>
        <div className={styles.containerField}>
          <StyledSelect
            name='client'
            label='Choisir un client'
            control={control}
            options={clients}
            isDisabled={!!clientId}
            isSearchable
          />
        </div>
        <div className={styles.containerField}>
          <StyledSelect
            name='agency'
            label='Agence'
            isDisabled={agencies.length === 1}
            control={control}
            options={agencies}
          />
        </div>
      </div>
      <div className={styles.buttons}>
        <button className='invisible'>Annuler</button>
        <button disabled={isLoading} onClick={handleSubmit(submit)}>
          <span className='icon'>{BsCheck({})}</span>
          <span>Valider</span>
        </button>
      </div>
    </div>
  );
};

export default CreateEtaiement;
